import React, { useState, useEffect } from 'react';
import { Input, Form, Typography } from 'antd';
import PropTypes from 'prop-types';
import NoteText from './NoteText';
import { slugRegex } from '../../util';

const SiteDataForm = ({ pageDetails, handleChange, type, pageHost }) => {
  const [title, setTitle] = useState(pageDetails?.title || '');
  const [description, setDescription] = useState(
    pageDetails?.description || ''
  );
  const [slug, setSlug] = useState(pageDetails?.customSlug || '');
  const [customHeaderTags, setCustomHeaderTags] = useState(
    pageDetails?.customHeaderTags || ''
  );

  useEffect(() => {
    if (type === 'edit') {
      setTitle(pageDetails?.title);
      setDescription(pageDetails?.description);
      setSlug(pageDetails?.customSlug);
      setCustomHeaderTags(pageDetails?.customHeaderTags);
    }
  }, [pageDetails]);

  useEffect(() => {
    handleChange({
      title,
      description,
      customSlug: slug,
      customHeaderTags,
    });
  }, [title, description, slug]);

  return (
    <Form className="creatrVideoCallForm">
      <Form.Item className="vcInputWrapper">
        <Input
          required
          name="title"
          showCount
          maxLength={100}
          size="large"
          className="vcInput"
          placeholder="Add website title"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
        />
      </Form.Item>
      <Form.Item className="vcInputWrapper">
        <Input.TextArea
          required
          name="description"
          className="vcInput"
          placeholder="Add website description"
          autoSize={{ minRows: 4, maxRows: 6 }}
          value={description}
          onChange={(e) => setDescription(e.target.value)}
        />
      </Form.Item>
      <Form.Item className="vcInputWrapper">
        <Input.TextArea
          required
          name="customHeaderTags"
          className="vcInput"
          placeholder="Add custom header tags"
          autoSize={{ minRows: 4, maxRows: 6 }}
          value={customHeaderTags}
          onChange={(e) => setCustomHeaderTags(e.target.value)}
        />
      </Form.Item>
      <Form.Item className="vcInputWrapper">
        <Input
          required
          name="customSlug"
          showCount
          maxLength={20}
          size="large"
          className="vcInput"
          placeholder="Add a url suffix"
          pattern={slugRegex}
          value={slug}
          onChange={(e) => {
            if (
              e.target.value.length === 0 ||
              e.target.value.match(/^[a-z0-9-_]+$/)
            ) {
              setSlug(e.target.value);
            }
          }}
        />
        <Typography.Paragraph style={{ margin: '10px 0' }}>
          Your website url would look like this:{' '}
          <a>{`https://${
            pageHost || process.env.REACT_APP_LANDING_PAGE_DOMAIN
          }/${slug || '<suffix>'}`}</a>
        </Typography.Paragraph>
        <div style={{ marginTop: '10px' }}>
          <NoteText text="The slug must contain only letters, digits, hyphen and underscores. (ensure not to use adjacent hypens and underscores and also not at the end of the slug)" />
        </div>
      </Form.Item>
    </Form>
  );
};

SiteDataForm.propTypes = {
  pageDetails: PropTypes.shape(Object),
  handleChange: PropTypes.func,
  type: PropTypes.string,
  pageHost: PropTypes.string,
};

export default SiteDataForm;
